// Redirection après connexion.
// - Desktop : comportement historique -> hub /dashboard.
// - Mobile : on emmène directement l'utilisateur TESTER son agent (moins de friction).
//     * 1 seul agent  -> son playground.
//     * plusieurs      -> liste d'agents (il choisit lequel tester).
//     * aucun          -> liste d'agents (création).
import rawAxios from 'axios';
import { apiBaseUrl } from '@/config';
import { isMobileDevice } from '@/utils/device';

export async function redirectAfterLogin(router, token) {
  if (!isMobileDevice()) {
    router.push('/dashboard');
    return;
  }
  try {
    const r = await rawAxios.get(`${apiBaseUrl}/get/list/chatbots`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      validateStatus: () => true
    });
    const bots = (r.status === 200 && r.data && r.data.chatbots) || [];
    if (bots.length === 1 && bots[0] && bots[0]._id) {
      router.push(`/dashboard/chatbots/${bots[0]._id}/playground`);
    } else {
      // plusieurs (sélection) ou aucun (création) -> liste d'agents
      router.push('/dashboard/chatbots');
    }
  } catch (_) {
    router.push('/dashboard');
  }
}
